import { Box } from "@mui/material";
import React from "react";
import InstituteAdminDashboard from "./InstituteAdminDashboard";
import SuperAdminDashboard from "./SuperAdminDashboard";
import TrainerDashboard from "./TrainerDashboard";
import InterviewerDashboard from "./InterviewerDashboard";
import CorporateDashboard from "./CorporateDashboard";
import CandidateDashboard from "./CandidateDashboard";
import CorporateInterviewerDashboard from "./CorporateInterviewerDashboard";
import { useOrganizations, useSelectedOrganizationId } from "../../store/useDynamicLabel";

const Dashboard = () => {
  const organizations = useOrganizations();
  const selectedOrganizationId = useSelectedOrganizationId();
  const superAdminCorporate =
    organizations.find((org) => org.id === selectedOrganizationId)?.name === "corporate";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        p: 1,
      }}
    >
      {(() => {
        const role = localStorage.getItem("role");
        const isCorporate = localStorage.getItem("organization_name") === "corporate";

        if (isCorporate && (role === "INSTITUTE_ADMIN" || role === "TRAINER")) return <CorporateDashboard />;
        if (isCorporate && role === "STUDENT") return <CandidateDashboard />;
        if (isCorporate && role === "INTERVIEWER") return <CorporateInterviewerDashboard />;
        if (role === "INSTITUTE_ADMIN") return <InstituteAdminDashboard />;
        if (role === "SUPER_ADMIN") return superAdminCorporate ? <CorporateDashboard /> : <SuperAdminDashboard />;
        if (role === "INTERVIEWER") return <InterviewerDashboard />;
        if (role === "STUDENT" || role === "TRAINER")
          return <TrainerDashboard />;

        return null;
      })()}
    </Box>
  );
};

export default Dashboard;
